import { Injectable, signal } from '@angular/core';
import { ActivatedRouteSnapshot, Data } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class RouteStateService {
	readonly currentRouteData = signal<Data | null>(null);
	readonly parentRoute = signal<ActivatedRouteSnapshot | null>(null);

	updateRouteData(data: Partial<Data>): void {
		this.currentRouteData.update((prev) => ({ ...(prev ?? {}), ...data }));
	}

	setRoute(route: ActivatedRouteSnapshot): void {
		this.currentRouteData.set(route.data);
		this.parentRoute.set(route.parent);
	}

	reset(): void {
		this.currentRouteData.set(null);
		this.parentRoute.set(null);
	}
}
